import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.module.css';

const Image = (props) => {
  const {
    image,
    altText,
    onClick = () => {},
    customImageContainerStyle,
    customImageStyle,
    imageContainerInlineStyle,
    style,
  } = props;
  return (
    <div
      className={classNames(
        styles.imageContainerStyle,
        customImageContainerStyle
      )}
      style={imageContainerInlineStyle}
      onClick={onClick}
    >
      <img
        src={image}
        alt={altText}
        loading="lazy"
        className={classNames(styles.imageStyle, customImageStyle)}
        style={style}
      />
      {props.children}
    </div>
  );
};

Image.propTypes = {
  altText: propTypes.string,
  onClick: propTypes.func,
  image: propTypes.string,
  customImageContainerStyle: propTypes.string,
  customImageStyle: propTypes.string,
  imageContainerInlineStyle: propTypes.object,
  style: propTypes.object,
};

export { Image };
